"use client";

import { createContext, useContext, useState } from "react";

const BannerContext = createContext();

export const useBanner = () => {
  const context = useContext(BannerContext);
  if (!context) {
    return { activeSlide: 0, setActiveSlide: () => {} };
  }
  return context;
};

export const BannerProvider = ({ children }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <BannerContext.Provider value={{ activeSlide, setActiveSlide }}>
      {children}
    </BannerContext.Provider>
  );
};